import { ajax as request } from '@blade/common';
/** ==============================@Description: 通行任务============================== */
/**
*@Description: 查询任务列表
*@Date: 2020-09-01 14:39:57
*/
export const getPassTaskList = (data) => request({
    url: '/api/access-management/api/v1/pass/task/query',
    method: 'POST',
    data,
});
/**
*@Description: 添加通行任务
*@Date: 2020-09-01 14:39:57
*/
export const createPassTask = (data) => request({
    url: '/api/access-management/api/v1/pass/task/add',
    method: 'POST',
    data,
});
// 编辑通行任务时，获取该通行任务的信息
export const editPassTask = (taskId) => request({
    url: '/api/access-management/api/v1/pass/task/' + taskId,
    method: 'GET',
});
// 编辑更新通行任务
export const updatePassTask = (data) => request({
    url: '/api/access-management/api/v1/pass/task/update',
    method: 'POST',
    data,
});
// 删除通行任务
export const deletePassTask = (taskId) => request({
    url: '/api/access-management/api/v1/pass/task/' + taskId,
    method: 'DELETE',
});
// 新增任务页面中获取黑||白||访客名单
export const getGroupList = (data) => request({
    url: '/api/portrait-management/api/v1/pass/portraitLib/query/group',
    method: 'GET',
    params: { ...data },
});
export const getDeviceTaskDetail = (data) => request({
    url: '/api/access-management/api/v1/pass/task/device/detail',
    method: 'POST',
    data,
});
/**
*@Description: 查询二维码任务列表
*@Date: 2020-09-01 14:39:57
*/
export const getQrTaskList = (data) => request({
    url: '/api/access-management/api/v1/pass/qr/task/list',
    method: 'POST',
    data,
});
export const postQrTask = (data) => request({
    url: '/api/access-management/api/v1/pass/qr/task/add',
    method: 'POST',
    data,
});
// 查看二维码任务详情
export const getQrTaskDetail = (taskId) => request({
    url: `/api/access-management/api/v1/pass/qr/task/${taskId}`,
    method: 'GET',
});
// 删除二维码任务
export const deleteQrTask = (taskId) => request({
    url: `/api/access-management/api/v1/pass/qr/task/${taskId}`,
    method: 'DELETE',
});
// 修改二维码任务状态
export const updateQrTaskStatus = (taskId, newStatus) => request({
    url: `/api/access-management/api/v1/pass/qr/task/update/status/${taskId}/${newStatus}`,
    method: 'PUT',
});
// 查询二维码任务列表
export const queryQrTaskList = () => request({
    url: `/api/access-management/api/v1/pass/qr/task/query`,
    method: 'POST',
});
// 查询二维码任务列表
export const queryTaskStatus = (data) => request({
    url: `/api/access-management/api/v1/pass/task/detail`,
    method: 'POST',
    data,
});
